import { searchBox as searchBoxWidget } from "instantsearch.js/es/widgets";
// https://www.algolia.com/doc/api-reference/widgets/search-box/js/#widget-param-templates
export const siteSearchBox = searchBoxWidget({
  container: '#searchbox',
  placeholder: 'Search this site...',
  showReset: true,
  showSubmit: false,
  showLoadingIndicator: false,
  cssClasses: {
    root: [
      'w-full'
    ],
    form: [
      'w-full form'
    ],
    input: [
      'bg-gray block w-full rounded-none rounded-l-md border-0 py-4 px-5 placeholder:text-gray-600',
    ],
    reset: [
      'h-full w-8 flex items-center justify-center absolute top-0 right-0 focus:ring-1 opacity-0'
    ],
    resetIcon: [
      ''
    ]
  },
})
